module.exports = __webpack_public_path__ + "static/media/panorama.77a88f26.webp";